import { Component } from '@angular/core';

@Component({
  selector: 'app-things',
  standalone: true,
  imports: [],
  templateUrl: './things.component.html',
  styleUrl: './things.component.scss'
})
export class ThingsComponent {

}
